import { render } from "./EduRegisterPayPage.vue?vue&type=template&id=517b8e22"
import script from "./EduRegisterPayPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterPayPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__